export class SingletonInitService {
  wasInit = false
  getWasInit = () => this.wasInit
  setWasInit = (wasInit: boolean) => {
    this.wasInit = wasInit
  }
}
